import { Autocomplete, TextField } from "@mui/material";
import { useCentroCustoStore } from "../../stores/comercial/centrocusto";
import { useEffect } from "react";


interface Props {
  value: number[]
  onChange: (value: number[]) => void
  helpMessage?: string
  required?: boolean
  erro?: boolean
  disabled?: boolean
}

function CentroCustoMultipleSelect({ value, onChange, helpMessage = "", required = false, erro = false, disabled = false }: Props) {
  const { centroCustoResume, setCentroCustoResume, loadingCentroCustoResume, erroCentroCustoResume } = useCentroCustoStore()

  useEffect(() => {
    if (centroCustoResume.length === 0) {
      setCentroCustoResume()
    }
  }, [])

  return (
    <Autocomplete
      multiple
      id="centro-custo-multiple-select"
      options={centroCustoResume}
      onOpen={async () => {
        if (centroCustoResume.length === 0) {
          await setCentroCustoResume()
        }
      }}
      value={centroCustoResume.filter((option) => value.includes(option.idCentroCusto))}
      getOptionLabel={(option) => `${option.codigo} - ${option.descricao}`}
      onChange={(event, newValue) => {
        const selectedIds = newValue.map((option) => option.idCentroCusto);
        onChange(selectedIds);
      }}
      isOptionEqualToValue={(option, selectedOption) => option.idCentroCusto === selectedOption.idCentroCusto}
      getOptionKey={(x) => x.idCentroCusto}
      filterSelectedOptions
      loading={loadingCentroCustoResume}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          disabled={disabled}
          required={required}
          label="Centro de custo"
          error={erroCentroCustoResume || erro}
          helperText={erroCentroCustoResume == true ? "Houve algum erro ao buscar os centros de custo" : helpMessage}
        />
      )}
    />
  );
}

export default CentroCustoMultipleSelect;